import React from 'react'

import { BigCalendarProps } from '../../BigCalendar'
import { BigCalendarMonth } from '../../utils/use-big-calendar'
import SeasonMonthButton from '../../../../../../house-options/shared/components/seasonal-busyness-calendar/components/grid/components/SeasonMonthButton'

type BigCalendarToolbarProps = Pick<BigCalendarProps, 'house'> & {
  calendarMonth: BigCalendarMonth
}
export const BigCalendarToolbar = ({
  house,
  calendarMonth,
}: BigCalendarToolbarProps) => {
  const { seasonalBusynessKey, label } = calendarMonth

  return (
    <div className='my-2 flex items-center text-lg capitalize'>
      <SeasonMonthButton
        className='mr-1 h-[15px] w-[15px]'
        startSeason={
          house.options.seasonalBusynessCalendar[0].months[seasonalBusynessKey]
            ?.firstHalf
        }
        endSeason={
          house.options.seasonalBusynessCalendar[0].months[seasonalBusynessKey]
            ?.secondHalf
        }
      />
      {label}
    </div>
  )
}
